import React, { useCallback } from 'react';
import Timeline, {
  TimelineHeaders,
  SidebarHeader,
  CustomHeader,
  TimelineMarkers,
  CustomMarker,
} from 'react-calendar-timeline';
import { BookingTimelineContainer } from './styles';
import SideBarTitleContainer from './SideBarTitleContainer';
import TimelineHeader from './TimelineHeader';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import colors from 'constants/colors';

const keys = {
  groupIdKey: 'id',
  groupTitleKey: 'title',
  groupRightTitleKey: 'rightTitle',
  itemIdKey: 'id',
  itemTitleKey: 'title',
  itemDivTitleKey: 'title',
  itemGroupKey: 'group',
  itemTimeStartKey: 'start',
  itemTimeEndKey: 'end',
  groupLabelKey: 'title',
};

const TimelineTable = ({
  timelineState,
  items,
  setItems,
  SideBarTitle,
  SideBarItem,
  itemRenderer,
  ClientModal,
  moveResizeValidator,
  handleItemClick,
  handleItemDoubleClick,
  handleItemMove,
  clientModalOpen,
  setClientModalOpen,
  bookingDetailsData,
  setBookingDetailsData,
  sidebarWidth=100,
  fixedHeader,
}) => {

  const {
    visibleTimeStart,
    visibleTimeEnd,
    today,
    endToday,
  } = timelineState.state;

  const { state, setState } = timelineState;

  const handleTimeChange = useCallback(
    (visibleTimeStart, visibleTimeEnd, updateScrollCanvas) => {
      // Update state with new visible range
      setState({
        ...state, 
        visibleTimeStart: visibleTimeStart,
        visibleTimeEnd: visibleTimeEnd, 
      });
      
      // Required to confirm the change
      updateScrollCanvas(visibleTimeStart, visibleTimeEnd);
    },
    []
  );

  return (
    <BookingTimelineContainer open={clientModalOpen} fixedHeader={fixedHeader}>
      <Timeline
        groups={SideBarItem}
        items={items}
        keys={keys}
        fullUpdate={false}
        minZoom={60 * 60 * 1000 * 24 * 3}
        maxZoom={60 * 60 * 1000 * 24 * 90}
        itemTouchSendsClick={false}
        stackItems={false}
        sidebarWidth={sidebarWidth}
        itemHeightRatio={1}
        moveResizeValidator={moveResizeValidator}
        onItemClick={(itemId, e, time) => {
          if(handleItemClick) {
            handleItemClick(itemId, e, time);
          }
        }}
        onItemSelect={(itemId, e, time) => {
          if(handleItemClick) {
            handleItemClick(itemId, e, time);
          }
        }}
        onItemMove={(itemId, dragTime, newGroupOrder) => {
          if(handleItemMove) {
            handleItemMove(itemId, dragTime, newGroupOrder)
          }
        }}
        onItemDoubleClick={(itemId, e, time) => {
          if(handleItemDoubleClick) {
            handleItemDoubleClick(itemId, e, time);
          }
        }}
        traditionalZoom={true}
        visibleTimeStart={visibleTimeStart}
        visibleTimeEnd={visibleTimeEnd}
        onTimeChange={handleTimeChange}
        timeSteps={{
          second: 0,
          minute: 0,
          hour: 0,
          day: 1,
          month: 0,
          year: 0
        }}
        itemRenderer={itemRenderer}
      >
        <TimelineHeaders
          className="timelineHeaders"
          calendarHeaderClassName="timelineHeader"
        >
          <SidebarHeader>
            {({ getRootProps }) => (
              <SideBarTitleContainer getRootProps={getRootProps} title={SideBarTitle} />
            )}
          </SidebarHeader>
          <CustomHeader height={50} unit="day">
            {({
              headerContext: { intervals },
              getRootProps,
              getIntervalProps,
            }) =>
              TimelineHeader({
                intervals,
                getRootProps,
                getIntervalProps,
              })
            }
          </CustomHeader>
        </TimelineHeaders>
        <TimelineMarkers>
          <CustomMarker date={moment(today).tz(TIME_ZONE).valueOf()}>
            {({ styles }) => {
              const customStyles = {
                ...styles,
                backgroundColor: colors.green,
                width: '1px',
                zIndex: '200'
              };
              return <div style={customStyles} />;
            }}
          </CustomMarker>
          <CustomMarker date={moment(endToday).tz(TIME_ZONE).valueOf()}>
            {({ styles }) => {
              const customStyles = {
                ...styles,
                backgroundColor: colors.green,
                width: '1px',
                zIndex: '200'
              };
              return <div style={customStyles} />;
            }}
          </CustomMarker>
        </TimelineMarkers>
      </Timeline>
      {ClientModal ? (
        <ClientModal
          clientModalOpen={clientModalOpen}
          setClientModalOpen={setClientModalOpen}
          bookingDetailsData={bookingDetailsData}
          setBookingDetailsData={setBookingDetailsData}
          setItems={setItems}
        />
      ) : null}
    </BookingTimelineContainer>
  );
};

export default TimelineTable;
